import React, { useState } from "react";
import Select from "react-select";

// @mui material components
import Grid from "@mui/material/Grid";

// Dashboard components
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";

import TensileTest from "./Tensile-Test";
import HardnessTest from "./hardness-test";
import NotchImpactTest from "./notch-impact-test";
import ThermalStabilityTest from "./thermal-Stability-Test"

const ProductTestingMaster = () => {
  const testingOptions = [
    { label: "Tensile Test", value: "tensile" },
    { label: "Hardness Test", value: "hardness" },
    { label: "Notch Impact Test", value: "notchImpact" },
    { label: "Thermal Stability Test", value: "thermalStability" },
  ];

  const [selectedTestType, setSelectedTestType] = useState(testingOptions[0]);

  const handleTestTypeChange = (selectedOption) => {
    setSelectedTestType(selectedOption);
  };

  const dropdownUI = (
    <div style={{ width: "250px" }}>
      <Select
        className="select-css"
        placeholder="Choose Test Type..."
        options={testingOptions}
        value={selectedTestType}
        onChange={handleTestTypeChange}
        isClearable={false}
        maxMenuHeight={200}
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );

  const renderActiveTestComponent = () => {
    switch (selectedTestType?.value) {
      case "tensile":
        return <TensileTest dropdownUI={dropdownUI} />;
      case "hardness":
        return <HardnessTest dropdownUI={dropdownUI} />;
      case "notchImpact":
        return <NotchImpactTest dropdownUI={dropdownUI} />;
      case "thermalStability":
        return <ThermalStabilityTest dropdownUI={dropdownUI} />;
      default:
        return <TensileTest dropdownUI={dropdownUI} />;
    }
  };

  return (
    <div>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {renderActiveTestComponent()}
          </Grid>
        </Grid>
      </MDBox>
    </div>
  );
};

export default ProductTestingMaster;